import Icon from '../ui/Icon';

/**
 * Shown when a cancelled checkout is restored from localStorage.
 *
 * role="status" so the restoration is announced: a screen reader user otherwise has no way to
 * know their previous selections were reinstated, which changes what they are about to buy.
 */
export default function ResumeBanner({ onDismiss }) {
  return (
    <div role="status" className="border-b border-gray-200 bg-gray-50 px-4 py-3.5 sm:px-7">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <Icon name="infoCircle" className="w-5 h-5 text-primary-600 flex-shrink-0" />
          <div>
            <h3 className="text-sm font-medium text-gray-900">Checkout Resumed</h3>
            <p className="text-sm text-gray-600">
              Your previous selections have been restored. You can continue where you left off.
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={onDismiss}
          // Was a 16px icon with no accessible name and a sub-44px hit area. p-2 brings the
          // target closer to the 44px guidance and aria-label gives it a name.
          aria-label="Dismiss checkout resumed message"
          className="p-2 -m-1 text-gray-500 hover:text-gray-800 rounded focus:outline-none focus:ring-2 focus:ring-primary-500 flex-shrink-0"
        >
          <Icon name="close" className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
